import { client as workspaceClient } from '@inference.engine/workspace-api-client/web';
import { ENV } from '@/lib/config/env';
import { configureApiClient } from './configure-client';
import { projectIdRequestInterceptor } from './interceptors/project-id.interceptor';

if (!ENV.WORKSPACE_API_BASE_URL) {
  throw new Error('WORKSPACE_API_BASE_URL environment variable is not set');
}

workspaceClient.setConfig({
  throwOnError: true,
});

export const workspaceHttp = configureApiClient(workspaceClient, ENV.WORKSPACE_API_BASE_URL);

workspaceHttp.instance.interceptors.request.use(projectIdRequestInterceptor);
